export default "__VITE_ASSET__76ab3688__"